import React from "react";
import styled from "styled-components";
import MenuFooter from "./global/MenuFooter";
import MenuFooterBottom from "./global/MenuFooterBottom";
import SnigCopy from "./global/SnigCopy";
import SocialsLinks from "./global/SocialsLinks";
import {useACFOptions} from "../_hooks/useACFOptions";


const TagLine = styled.p`
  font-weight: 400;
  font-family: var(--bs-cubano-font-family);
  svg {
    //transform: rotate(-22deg);
    left: 0;
    bottom: 10px;
    @media (min-width: 640px) {
      width: 100px;
      height: 100px;
    }
    @media (min-width: 1200px) {
      width: 130px;
      height: 130px;
      bottom: 36px;
      left: -4px;
    }
  }
`
export const Footer = ({pattern = 'gs-pattern gs-pattern--8'}) => {
  const {footer} = useACFOptions();

  const tagline = footer?.tagline ? footer.tagline.replace('*1*', "<span class='position-relative'><svg class='position-absolute' width='75' height='75'><use xlink:href='#icon-gots-logo'></use></svg></span>") : '';

  return (
    <footer className={`bg-forest-green text-white pt-50 pb-40 pt-lg-100 ${pattern}`}>
      <div className="container">
        <div className="row mb-32 mb-lg-80">
          <div className="col-12 col-lg-6">
            {footer?.tagline && (
              <TagLine className="h2 fs-md-68 fs-xl-80 text-white text-uppercase mb-40 mb-lg-68" dangerouslySetInnerHTML={{__html: tagline}}></TagLine>
            )}
            <div className={'d-none d-lg-block'}>
              <SocialsLinks items={footer?.socials || []}/>
            </div>
          </div>
          <div className="col-12 col-lg-6 col-xl-5 offset-xl-1 mb-32 mb-lg-0">
            <MenuFooter location={'FOOTER_NAV'}/>
          </div>
          <div className="col-12 d-lg-none">
            <SocialsLinks items={footer?.socials || []}/>
          </div>
        </div>
        <div className="row row-gap-24 justify-content-between align-items-center">
          <div className="col-12 col-md-5 col-lg-5 col-xl-3">
            {footer?.copyright && (
              <p className="mb-0 fw-700 fs-14 letter-spacing-n015 lh-125">{footer.copyright.replace('[year]', new Date().getFullYear())}</p>
            )}
          </div>
          <div className="col-12 col-md-7 col-lg-7 col-xl-4 d-md-flex justify-content-md-end d-xl-block">
            <MenuFooterBottom location={'FOOTER_BOT_NAV'}/>
          </div>
          <div className="col-md-12 col-xl-4 text-xl-end py-xl-10">
            <SnigCopy/>
          </div>
        </div>
      </div>
    </footer>
  );
};
